/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLast_story = {
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_story" | "ReplyListContainerLastFlattened_story">;
    readonly " $refType": "ReplyListContainerLast_story";
};
export type ReplyListContainerLast_story$data = ReplyListContainerLast_story;
export type ReplyListContainerLast_story$key = {
    readonly " $data"?: ReplyListContainerLast_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLast_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "flattenReplies"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLast_story",
    "selections": [
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LocalReplyListContainer_story"
                }
            ]
        },
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReplyListContainerLastFlattened_story"
                }
            ]
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '16cf5d2a8e851c5ff32303d157c61909';
export default node;
